import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  FeatureSource,
  ModelBase,
} from "@models";
import { 
  SpecialFeature 
} from "@dndModels";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";
import CommonUtilities from "@utilities/common_utilities";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import CheckBox from "@components/input/CheckBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function SpecialFeatureEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<SpecialFeature>(param_obj instanceof SpecialFeature ? param_obj : api.applyWorkingOn(new SpecialFeature()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="special_feature"
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof SpecialFeature) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
      header={
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            { disabled ? 
              <><span className="header">Type:</span> { obj.type }</>
            :
              <StringBox 
                name="Type"
                value={obj.type} 
                onBlur={(value: string) => {
                  const new_obj = obj;
                  new_obj.type = value;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { disabled ? 
              <>{ obj.repeatable && <span className="header">Repeatable</span> }</>
            :
              <CheckBox 
                name="Repeatable"
                value={ obj.repeatable } 
                onChange={(value: boolean) => {
                  const new_obj = obj;
                  new_obj.repeatable = value;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            }
          </Grid>
        </Grid>
      }>
    </FeatureSourceInput>
  ); 
}
